module.exports = __webpack_public_path__ + "static/media/about3.80460aa8.jpg";